import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  setTempId,
  setCustomFields,
  deleteCustomField,
} from "../../redux/actions/customFieldsActions";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import EnhancedTableToolbar from "./EnhancedTableToolbar";
import EnhancedTableHead from "./EnhancedTableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import CreateCustomField from "./CreateCustomField";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CreateIcon from "@material-ui/icons/Create";
import Snackbar from "@material-ui/core/Snackbar";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from "@material-ui/icons/Done";
import CloseIcon from "@material-ui/icons/Close";
import { contentClient } from "../../AxiosClient";
import moment from "moment";
import { DatePicker } from "@material-ui/pickers";
import ErrorIcon from "@material-ui/icons/Error";
import GlobalCustomFieldAdd from "./GlobalCustomFieldAdd";
const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  error: {
    color: theme.palette.error.light,
  },
  wrapper: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
});

export class CustomFields extends Component {
  state = {
    currentCustomFields: [],
    createCustomFieldOpen: false,
    selected: [],
    selectedForEdit: null,
    index: null,
    prevCustomFields: [],
    indexTextFocus: null,
    itemIndex:null,
    snackBar: false,
    GlobalCustomFieldAddOpen: false,
  };
  componentDidMount() {
    if (this.props.currentCustomFields.length > 0) {
      this.setState({ currentCustomFields: this.props.currentCustomFields });
    }
    if (this.props.global) {
      this.getGlobalCustomFields();
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.currentCustomFields !== this.props.currentCustomFields) {
      this.setState({ currentCustomFields: this.props.currentCustomFields });
    }
  }
  addFromGlobal = (globalCustomFields) => {
    globalCustomFields.forEach((gcf,idx)=>{
      gcf.tempId = new Date().getTime() + idx;
    })
    let newCustomFields = [
      ...this.state.currentCustomFields,
      ...globalCustomFields,
    ];
    this.setState({
      GlobalCustomFieldAddOpen: false,
    });
    this.props.setTempId(this.props.tempId + globalCustomFields.length);
    this.props.setCustomFields(newCustomFields);
  };
  getDetailsFromPropertyValues = (propertyValues) => {
    let details = ""
    if (propertyValues.hasOwnProperty("minimum")) {
      details += propertyValues.minimum 
        ? "> " + moment(propertyValues.minimumValue).format("LLLL")
        : ""
    }
    if (propertyValues.hasOwnProperty("maximum")) {
      details += propertyValues.maximum 
        ? "< " + moment(propertyValues.maximumValue).format("LLLL")
        : ""
    }
    return details.trim().length > 0 ? details : JSON.stringify(propertyValues)
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={this.props.global && classes.wrapper}>
        <Dialog
          onClose={this.clearEdit}
          open={this.state.createCustomFieldOpen}
        >
          {this.state.createCustomFieldOpen && (
            <CreateCustomField
              close={() => {
                this.setState({
                  createCustomFieldOpen: !this.state.createCustomFieldOpen,
                  selectedForEdit: null,
                });
              }}
              index={this.state.index}
              selectedForEdit={this.state.selectedForEdit}
              editCustomField={this.editCustomField}
              addCustomField={this.addCustomField}
            />
          )}
        </Dialog>

        <div className={classes.root}>
          <Paper className={classes.paper}>
            <EnhancedTableToolbar
              slate={this.props.slate}
              // global={this.props.global}
              template={this.props.template}
              content={this.props.content}
              numSelected={this.state.selected.length}
            />
            <div className={classes.tableWrapper}>
              <Table className={classes.table} aria-labelledby="tableTitle">
                <EnhancedTableHead
                  numSelected={this.state.selected.length}
                  onSelectAllClick={this.handleSelectAllClick}
                  rowCount={this.state.currentCustomFields.length}
                />
                <TableBody>
                  {this.state.currentCustomFields.map((row, index) => {
                    const isItemSelected = this.isSelected(row);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    let propertyValues  = row.propertyValues ? JSON.parse(row.propertyValues) : "";
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isItemSelected}
                      >
                        <TableCell padding="checkbox">
                          {this.props.slate && (
                            <Checkbox
                              onClick={() => this.setSelected(row)}
                              checked={isItemSelected}
                              inputProps={{ "aria-labelledby": labelId }}
                            />
                          )}
                        </TableCell>
                        <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          style={{ paddingLeft: "16px" }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            {this.props.contentSetup &&
                              row.mandatory &&
                              (row.value === "" ||
                                row.value === null ||
                                (row.fieldType === "multiselect" &&
                                  row.value === "[]")) && (
                                <Tooltip
                                  title={"Requires a value"}
                                  aria-label={"Requires a value"}
                                >
                                  <ErrorIcon className={classes.error} />
                                </Tooltip>
                              )}
                            <div style={{ paddingLeft: 4 }}>{row.name}</div>
                          </div>
                        </TableCell>
                        <TableCell>{row.fieldType}</TableCell>
                        <TableCell>
                          {Array.isArray(propertyValues) 
                            ? propertyValues.join(" ")
                            : typeof propertyValues === 'object' && propertyValues !== null
                              ? this.getDetailsFromPropertyValues(propertyValues)
                              : propertyValues
                          }
                        </TableCell>
                        <TableCell>
                          {this.props.global ? (
                            row.fieldType === "date" ? (
                              moment(row.value).format("DD/MM/YYYY")
                            ) : (
                              row.value
                            )
                          ) : row.fieldType === "input" ? (
                            <TextField
                              aria-label="Custom field text input"
                              autoFocus={index === this.state.itemIndex}
                              fullWidth
                              required
                              value={row.value}
                              onFocus={(event)=>{
                                this.state.indexTextFocus && index === this.state.itemIndex && event.target.setSelectionRange(this.state.indexTextFocus,this.state.indexTextFocus);
                              }}
                              onChange={(value) => {
                                this.updateValue(value.target.value, index, value.target.selectionStart);
                              }}
                              margin="normal"
                            />
                          ) : row.fieldType === "select" ||
                          row.fieldType === "multiselect" ? (
                            <div>
                              <Select
                                style={{ width: "100%" }}
                                multiple={row.fieldType === "multiselect"}
                                value={
                                  row.fieldType === "multiselect"
                                    ? row.value
                                      ? JSON.parse(row.value)
                                      : []
                                    : row.value
                                }
                                onChange={(value) =>
                                  this.updateValue(
                                    row.fieldType === "multiselect"
                                      ? JSON.stringify(value.target.value)
                                      : value.target.value,
                                    index
                                  )
                                }
                              >
                                {propertyValues.map(
                                  (name, idx) => (
                                    <MenuItem key={idx} value={name}>
                                      {name}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                            </div>
                          ) : (
                            row.fieldType === "date" && (
                              <DatePicker
                                minDate={propertyValues.minimum ? moment(
                                  propertyValues.minimumValue): new Date("1900-01-01")
                                }
                                maxDate={propertyValues.maximum ? moment(
                                  propertyValues.maximumValue) : new Date("2900-01-01")
                                }
                                autoOk
                                label={"Value"}
                                clearable
                                value={row.value > 0 ? row.value : null}
                                onChange={(date) =>
                                  this.updateValue(date, index)
                                }
                              />
                            )
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {(this.props.whatsUsingThem !== "content" &&
                            !this.props.global) ||
                          (!row.template && !this.props.global) ? (
                            <Checkbox
                              onClick={(event) => {
                                let newRow = row;
                                newRow.mandatory = event.target.checked;
                                this.editCustomField(newRow, index);
                              }}
                              checked={row.mandatory}
                            />
                          ) : row.mandatory ? (
                            <DoneIcon />
                          ) : (
                            <CloseIcon />
                          )}
                        </TableCell>
                        <TableCell align="right">
                          {(this.props.whatsUsingThem !== "content" ||
                            !row.template) && (
                            <>
                              <Tooltip title="Edit">
                                <IconButton>
                                  <CreateIcon
                                    onClick={() =>
                                      this.openEditCustomField(row, index)
                                    }
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Delete">
                                <IconButton
                                  onClick={() =>
                                    this.deleteCustomFields(row, index)
                                  }
                                  aria-label="Delete"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </div>
            <DialogActions>
              {this.state.GlobalCustomFieldAddOpen && (
                <GlobalCustomFieldAdd
                  close={() =>
                    this.setState({ GlobalCustomFieldAddOpen: false })
                  }
                  GlobalCustomFieldAddOpen={this.state.GlobalCustomFieldAddOpen}
                  addCustomFields={this.addFromGlobal}
                />
              )}
              {!this.props.global && (
                <Button
                  onClick={() =>
                    this.setState({ GlobalCustomFieldAddOpen: true })
                  }
                  color="primary"
                  aria-label="Add global custom field"
                >
                  <Trans i18nKey="global_custom_field_add" />
                </Button>
              )}
              <Button
                onClick={this.createCustomFieldDialogChange}
                color="primary"
                aria-label="Add custom field"
              >
                <Trans i18nKey="global_add" />
              </Button>
            </DialogActions>
          </Paper>
        </div>
        <Snackbar
          open={this.state.snackBar}
          id="customFieldDeletedSnack"
          message={this.props.t("custom_field_deleted")}
          action={
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.snackBarClose}
            />
          }
        />
      </div>
    );
  }
  snackBarClose = () => {
    this.setState({ snackBar: false });
  };
  deleteCustomFields = (row, idx) => {
    if (this.props.global) {
      contentClient.delete(`/customfield/${row.id}`).then((res) => {
        let array = this.state.currentCustomFields.splice(0);
        let selectedArray = this.state.selected.splice(0);
        for (let i = 0; i < array.length; i++) {
          if (res.data === array[i].id) {
            array.splice(i, 1);
          }
        }
        for (let j = 0; j < selectedArray.length; j++) {
          if (res.data === selectedArray[j].id) {
            selectedArray.splice(j, 1);
          }
        }

        this.setState({ selected: selectedArray, snackBar: true });
        this.props.deleteCustomField(res.data);
        this.props.setCustomFields(array);
        if (this.props.customFieldsChange) {
          this.props.customFieldsChange(array);
        }
      });
    } else {
      let array = this.state.currentCustomFields.splice(0);
      array.splice(idx, 1);
      this.props.setCustomFields(array);
      this.props.deleteCustomField(row);
      this.props.customFieldsChange(array);
    }
  };

  clearEdit = () => {
    this.setState({ selectedForEdit: null, index: null });
  };
  editCustomField = (row, index) => {
    let array = [];
    if (row.tempId || row.tempId === 0) {
      array = this.state.currentCustomFields.splice(0);
      array[index] = row;
      this.setState({
        createCustomFieldOpen: false,
        selectedForEdit: null,
      });
      this.props.setCustomFields(array);
    }
    if (this.props.global) {
      contentClient.patch(`/customfield/${row.id}`, row).then((res) => {
        let currentCustomField = res.data;
        let customFields = [...this.state.currentCustomFields];
        customFields.forEach((cf, index) => {
          if (cf.id === currentCustomField.id) {
            customFields[index] = currentCustomField;
          }
        });
        this.props.setCustomFields(customFields);
        this.setState({ createCustomFieldOpen: false, selectedForEdit: null });
      });
    }
  };

  openEditCustomField = (row, index) => {
    this.setState({
      selectedForEdit: row,
      index: index,
      createCustomFieldOpen: true,
    });
  };
  updateValue = (value, idx, textIdx) => {
    let array = this.state.currentCustomFields.splice(0);
    array[idx].value = value;
    this.props.setCustomFields(array);
    this.setState({ itemIndex: idx, indexTextFocus: textIdx });
  };
  setSelected = (row) => {
    let index = this.state.selected.indexOf(row);
    let selectedArray = this.state.selected;
    if (index === -1) {
      selectedArray = [...selectedArray, row];
      this.setState({ selected: selectedArray });
    } else {
      selectedArray.splice(index, 1);
      this.setState({ selected: selectedArray });
    }
    if (this.props.customFieldsChange) {
      this.props.customFieldsChange(selectedArray);
    }
  };
  addCustomField = (customField) => {
    this.setState({ createCustomFieldOpen: false });
    if (this.props.global) {
      contentClient.post(`/global/customfield/`, customField).then((res) => {
        let currentCustomField = res.data;
        this.props.setTempId(this.props.tempId + 1);
        this.props.setCustomFields([
          ...this.state.currentCustomFields,
          currentCustomField,
        ]);
      });
    } else {
      let tempId = this.props.tempId;
      customField.tempId = tempId + 1;
      this.setState({ createCustomFieldOpen: false });
      this.props.setTempId(tempId);
      this.props.setCustomFields([
        ...this.state.currentCustomFields,
        customField,
      ]);
    }
  };

  isSelected = (name) => this.state.selected.indexOf(name) !== -1;

  handleSelectAllClick = () => {
    if (this.state.selected.length < this.state.currentCustomFields.length) {
      this.setState({ selected: this.state.currentCustomFields });
      this.props.customFieldsChange(this.state.currentCustomFields);
    } else {
      this.setState({ selected: [] });
      this.props.customFieldsChange([]);
    }
  };

  createCustomFieldDialogChange = () => {
    this.setState({ createCustomFieldOpen: true });
  };

  getGlobalCustomFields = () => {
    contentClient.get(`/global/customfield/`).then((res) => {
      let currentCustomFields = res.data;
      let tempId = new Date().getTime();
      for (let i = 0; i < currentCustomFields.length; i++) {
        currentCustomFields[i].template = true;
        if (tempId < currentCustomFields[i].tempId) {
          tempId = currentCustomFields[i].tempId;
        }
      }
      this.props.setTempId(tempId);
      this.props.setCustomFields(currentCustomFields);
    });
  };
}
const mapStateToProps = (state) => ({
  tempId: state.customFields.tempId,
  currentCustomFields: state.customFields.currentCustomFields,
  whatsUsingThem: state.customFields.whatsUsingThem,
});
const mapDispatchToProps = {
  setTempId,
  setCustomFields,
  deleteCustomField,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(CustomFields)));
